export default __webpack_public_path__ + "static/media/hokkydana.b0a78640.png";